import { BaseItem } from '../common';

import * as NoteTranscriptCommand from './transcriptCommand';
import * as NoteTranscriptSegment from './transcriptSegment';
import * as NoteTranscriptSegmentFieldMap from './transcriptSegmentFieldMap';

export enum Kind {
  Dictation = 'DICTATION',
  Visit = 'VISIT',
}

export interface CreateValues {
  noteId: string;
  transcript: string;
  postLabelingTranscript: string | null;
  kind: Kind;
}

interface BaseValues extends CreateValues {
  isCurrent: boolean;
}

export interface NoteTranscript extends BaseValues, BaseItem {}

export interface NoteTranscriptWithSegmentEntities extends NoteTranscript {
  commands: NoteTranscriptCommand.NoteTranscriptCommand[];
  commandSegments: NoteTranscriptSegment.NoteTranscriptSegment[];
  segments: NoteTranscriptSegment.NoteTranscriptSegment[]; // deprecate
  segmentFieldMaps: NoteTranscriptSegmentFieldMap.NoteTranscriptSegmentFieldMap[];
  segmentFieldMapSegments: NoteTranscriptSegment.NoteTranscriptSegment[];
}
